import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import MenuOpciones from '../pages/MenuOpciones'; // Nuevo componente
import DashboardGenerales from '../pages/DashboardGenerales'; // Dashboard general
import CargarLayouts from '../pages/CargarLayouts'; // Página adicional
import ProtectedRoute from '../components/ProtectedRoute';
import HomePage from '../pages/HomePage';
import DashboardTablero from '../components/tableroComponentes/DashboardTablero'
import DashboardMujeres from '../components/tableroComponentes/DashboardMujeres'
import DashboardConcepto from '../components/tableroComponentes/DashboardConcepto'
import DashboardNomina from '../components/tableroComponentes/DashboardNomina'

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Ruta pública para Login */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Ruta protegida para MenuOpciones */}
        <Route
          path="/menu"
          element={
            <ProtectedRoute>
              <MenuOpciones />
            </ProtectedRoute>
          }
        />

        {/* Ruta protegida para el Dashboard general */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardTablero />
            </ProtectedRoute>
          }
        />

        {/* Ruta protegida para el Dashboard de Nómina */}
        <Route
          path="/dashboard-nomina"
          element={
            <ProtectedRoute>
              <DashboardNomina />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard-concepto"
          element={
            <ProtectedRoute>
              <DashboardConcepto/>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard-mujeres"
          element={
            <ProtectedRoute>
              <DashboardMujeres/>
            </ProtectedRoute>
          }
        />

        {/* Ruta protegida para cargar layouts */}
        <Route
          path="/cargar-layouts"
          element={
            <ProtectedRoute>
              <CargarLayouts />
            </ProtectedRoute>
          }
        />

        {/* Redirección por defecto */}
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
